import { render, staticRenderFns } from "./veStuLiteraryAwardShow.vue?vue&type=template&id=88c0bd56&scoped=true"
import script from "./veStuLiteraryAwardShow.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryAwardShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c0bd56",
  null
  
)

export default component.exports